module.exports = __webpack_public_path__ + "img/301.png";